<div class="container-fluid trans">
    <div class="row box-details h-100 align-items-center">
        <div class="col-12">
            <div
                class="d-flex flex-column justify-content-center align-items-center pt-4 pb-4 mt-2 mb-2"
            >
                <div class="pb-3">
                    <i
                        class="fa-sharp-duotone fa-light fa-3x fa-arrow-right-arrow-left"
                    ></i>
                </div>
                <div class="font-xl weight-medium pb-3">
                    Call Transferring to {{ contactSelected.name }}
                </div>
                <div class="font-med">
                    {{ now | date: 'HH:mm  dd/MM/y' }}
                </div>
            </div>
        </div>
    </div>
</div>
